// Nhập email hoặc số điện thoại → gửi link đặt lại mật khẩu đến email đăng ký. Khung chung components/auth/AuthStage.tsx.

import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Phone } from 'lucide-react'
import { post } from '@/lib/api'
import { AuthStage, AuthTitle } from '@/components/auth/AuthStage'
import { AuthBack, AuthError, AuthSubmit, finePointer } from '@/components/auth/AuthFields'

export default function ForgotPasswordPage() {
  const [identifier, setIdentifier] = useState('')
  const [sent, setSent] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!identifier.trim()) return
    setBusy(true)
    setError(null)
    try {
      await post('/auth/password/reset-request', { identifier: identifier.trim() })
      setSent(true)
    } catch (err) {
      setError((err as Error).message || 'Không gửi được, thử lại sau')
    } finally {
      setBusy(false)
    }
  }

  return (
    <AuthStage homeLink="/login">
      {sent ? (
        <>
          <AuthTitle sub="Kiểm tra email đăng ký, cả mục Spam. Link có hiệu lực 30 phút.">Đã gửi link đặt lại</AuthTitle>
          <Link to="/login" className="lg-btn2">Về đăng nhập</Link>
        </>
      ) : (
        <form onSubmit={onSubmit} noValidate>
          <AuthBack to="/login">Đăng nhập</AuthBack>
          <AuthTitle>Quên mật khẩu</AuthTitle>
          <div className="lg-field">
            <div className="lg-field-head"><label htmlFor="forgot-identifier">Số điện thoại hoặc Email</label></div>
            <div className="lg-input-wrap">
              <Phone className="lg-input-icon" aria-hidden />
              <input
                id="forgot-identifier"
                type="text"
                autoComplete="username"
                autoFocus={finePointer()}
                placeholder="Nhập số điện thoại hoặc email"
                className="lg-input"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
              />
            </div>
          </div>
          {error && <AuthError>{error}</AuthError>}
          <AuthSubmit busy={busy} busyLabel="Đang gửi…" disabled={!identifier.trim()}>Gửi link đặt lại</AuthSubmit>
        </form>
      )}
    </AuthStage>
  )
}
